import React, { useContext, useEffect } from 'react';
import { appContext } from "./../AppContext";
import { useFetch} from '@utils'
import {
    Redirect,
    Route
  } from 'react-router-dom';

export default function ProtectedPage(props) {

    const {startingUrl, ...routerProps} = props
    const [appState, AppDispatch] = useContext(appContext);
    const [doFetch] = useFetch();

    useEffect(() => {

        if(appState.user !== undefined) {
            const url = `/api/Account/GetCurrentUser`;
    
            doFetch(url)
                .then((response) => {
                    if(response.isSuccess) {
                        AppDispatch({ type: "LOGIN", payload: response.result })
                    }
    
                    AppDispatch({ type: "SETLOGINREDIRECT", payload: startingUrl })
                    return (<Redirect to={`/${appState.appName}/login`}/>)
                })
        }
    }, // eslint-disable-next-line
    [])

    if(appState.user === undefined) {
        AppDispatch({ type: "SETLOGINREDIRECT", payload: startingUrl })
        return (<Redirect to={`/${appState.appName}/login`}/>)
    }




    return <Route {...routerProps}/>

}